export enum MutationTypes {
  CREATE_SHIPPING_ADDRESS = 'CREATE_SHIPPING_ADDRESS',
  UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS',
  DELETE_SHIPPING_ADDRESS = 'DELETE_SHIPPING_ADDRESS',
  CHANGE_MAIN_SHIPPING_ADDRESS = 'CHANGE_MAIN_SHIPPING_ADDRESS',
  CLEAR_SHIPPING_ADDRESS = 'CLEAR_SHIPPING_ADDRESS',
}
